import { FC, useContext, useEffect, useState } from "react";
import { AppLoader } from "../../components/loading/LoadingOverlay";
import { useUnityListViewModel } from "../../../viewmodel/unity/UnityList";
import { FormModal } from "../../components/modal/FormModal";
import { Unity } from "../../../domain/unity";
import { useNavigate } from "react-router-dom";
import { PrimaryHeader } from "../../components/header/primary";
import { UnityData } from "./components/data";
import { DashboardHeaderContext } from "../../../hook/header";
import {
  faAdd,
  faFilter,
  faRefresh,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import { UserAuthContext } from "../../context/UserContext";
import { NewUnityInputList, UnityInputSchema } from "./modal/InputList";
import { useStyleContext } from "../../context/StyleContext";
import { SearchUnityModal } from "./modal/SearchModalView";
import UnityRepository from "../../../data/repository/UnityRepository";
import { set } from "lodash";
import { OrderUnityModal } from "./modal/OrderModalView";

const UnityPanel: FC = () => {
  const unityViewModel = useUnityListViewModel();
  const { appUser } = useContext(UserAuthContext);
  const navigate = useNavigate();
  const {
    //Order
    requestOrderEvent,

    fetchListState,
    createState,
    createEvent,
    createUnity,
    searchEvent,
    requestSearchEvent,
    onSearchEventCompleted,
    onOrderEventCompleted,
    onCreateStateReceived,
    onFetchStateReceived,
    onCreateEventCompleted,
    requestCreateEvent,
    requestRefreshEvent,
    unityList,
    refreshEvent,
    fetchUnityList,
    onRefreshEventCompleted,
  } = unityViewModel;

  const { stylePage } = useStyleContext();
  const dashboardHeaderContext = useContext(DashboardHeaderContext);

  const [searchLoading, setSearchLoading] = useState(false);
  const [searchResults, setSearchResults] = useState<Unity[] | null>(null);

  const [orderLoading, setOrderLoading] = useState(false);
  const [orderResults, setOrderResults] = useState<Unity[] | null>(null);

  const [showSearchModal, setShowSearchModal] = useState(false);
  const [showOrderModal, setShowOrderModal] = useState(false);

  /*eslint-disable*/
  useEffect(() => {
    if (createState !== null && !createState.loading) {
      if (createState.isSuccess()) {
        window.toast.success("Se creó la unidad.");
      } else {
        window.toast.error(createState!.error!.message);
      }
      requestRefreshEvent();
      onCreateStateReceived();
      onCreateEventCompleted();
    }
  }, [createState]);

  useEffect(() => {
    if (fetchListState !== null && !fetchListState.loading) {
      if (fetchListState.isFailed()) {
        window.toast.error(fetchListState!.error!.message);
      }
      onFetchStateReceived();
    }
  }, [fetchListState]);

  useEffect(() => {
    if (refreshEvent) {
      void fetchUnityList(true);
      onRefreshEventCompleted();
    }
  }, [refreshEvent]);

  const headerContext = useContext(DashboardHeaderContext);

  useEffect(() => {
    headerContext.setTheme({
      className: "bg-secondary-header",
      dark: true,
      title: "Unidades",
    });
    void fetchUnityList();
  }, []);

  const showLoadingOverlay =
    (fetchListState && fetchListState.loading) ||
    (createState && createState.loading);
  /*eslint-enable*/

  function onUnitySelected(unity: Unity) {
    navigate(`/dashboard/unity/${unity.id}/main`);
  }

  async function handleSearch(keyword: string) {
    try {
      setSearchLoading(true);
      const list = await UnityRepository.searchByKeyword(keyword);
      setSearchResults(list);
    } catch (e) {
      window.toast.error("Error al buscar unidades.");
      setSearchResults([]);
    } finally {
      setSearchLoading(false);
    }
  }

  <SearchUnityModal
    onSearch={handleSearch}
    onClose={() => {
      setShowSearchModal(false);
      unityViewModel.onSearchEventCompleted();
    }}
    results={searchResults}
    loading={searchLoading}
  />;

  return (
    <div
      className={
        "w-full overflow-y-auto overflow-x-hidden scrollbar-hide md:scrollbar-default"
      }
      style={stylePage}
    >
      <AppLoader isActive={showLoadingOverlay!} />
      {!!createEvent ? (
        <FormModal
          title={"Nueva Unidad"}
          inputList={NewUnityInputList}
          visible={true}
          onOk={createUnity}
          onCancel={onCreateEventCompleted}
          disabled={!!createState?.loading}
          okButtonLoading={createState?.loading}
          model={UnityInputSchema}
        />
      ) : null}

      {showOrderModal && (
        <OrderUnityModal
          onOrder={handleSearch}
          onClose={() => {
            setShowOrderModal(false);
            onOrderEventCompleted();
          }}
          results={orderResults}
          loading={orderLoading}
        />
      )}

      {showSearchModal && (
        <SearchUnityModal
          onSearch={handleSearch}
          onClose={() => {
            setShowSearchModal(false);
            onSearchEventCompleted();
          }}
          results={searchResults}
          loading={searchLoading}
        />
      )}

      <PrimaryHeader
        breadcrumbItems={[
          {
            label: "Unidades",
            active: true,
          },
        ]}
        title={"Unidades"}
        description={`${unityList?.length} unidad(es)`}
        actionsSchema={[
          {
            id: "add",
            icon: faAdd,
            label: "Nuevo",
            onClick: requestCreateEvent,
            hide: appUser.isClient() || !appUser.isAdmin(),
          },
          /*{
            id: "OrderBy",
            icon: faFilter,
            label: "Ordenar",
            onClick: () => {
              setShowOrderModal(true);
              requestOrderEvent();
            },
          },*/
          {
            id: "refresh",
            icon: faRefresh,
            label: "Actualizar",
            onClick: requestRefreshEvent,
          },
          {
            id: "search",
            icon: faSearch,
            label: "Buscar",
            onClick: () => {
              setShowSearchModal(true);
              requestSearchEvent();
            },
          },
        ]}
      />
      <div className={"w-full p-2 md:p-3 lg:p-5"}>
        <UnityData items={unityList} onClick={onUnitySelected} />
      </div>
    </div>
  );
};

export default UnityPanel;
function handleSearch(keyword: string): void {
  throw new Error("Function not implemented.");
}

function setShowSearchModal(arg0: boolean) {
  throw new Error("Function not implemented.");
}
